<template>
  <div class="sou-main">sousou</div>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
.sou-main {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #fff;
}
</style>